"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: bnpl/bnpl-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fbnpl%2Fbnpl-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.BnplServiceClient = exports.bnplErrorCodeToJSON = exports.bnplErrorCodeFromJSON = exports.SendDenialNoticeResponse = exports.SendDenialNoticeRequest = exports.GetInstallmentAmountPaidResponse = exports.GetInstallmentAmountPaidRequest = exports.CreateLoanResponse = exports.CreateLoanRequest = exports.GetLoanEligibilityResponse = exports.GetLoanEligibilityRequest = exports.GetPurchaseEligibilityResponse = exports.GetPurchaseEligibilityRequest = exports.GetUserEligibilityResponse = exports.GetUserEligibilityRequest = exports.LoanRequestFromBorrowCash = exports.LoanRequestFromPayment = exports.LoanRequest = exports.BnplErrorCode = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const account_1 = require("../account/account");
const amount_1 = require("../common/amount");
const fee_1 = require("../fee/fee");
const loan_eligibility_1 = require("./loan-eligibility");
const user_eligibility_1 = require("./user-eligibility");
const protobufPackage = 'com.step.bnpl.proto';
var BnplErrorCode;
(function (BnplErrorCode) {
    BnplErrorCode["INVALID_BNPL_ERROR_CODE"] = "INVALID_BNPL_ERROR_CODE";
    BnplErrorCode["BORROW_CIRCUIT_BREAKER"] = "BORROW_CIRCUIT_BREAKER";
    BnplErrorCode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(BnplErrorCode || (exports.BnplErrorCode = BnplErrorCode = {}));
function createBaseLoanRequest() {
    return { payment: undefined, borrowCash: undefined };
}
exports.LoanRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.payment)) {
            message.payment = exports.LoanRequestFromPayment.fromJSON(object.payment);
        }
        if (isSet(object.borrowCash)) {
            message.borrowCash = exports.LoanRequestFromBorrowCash.fromJSON(object.borrowCash);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.payment !== undefined) {
            obj.payment = exports.LoanRequestFromPayment.toJSON(message.payment);
        }
        if (message.borrowCash !== undefined) {
            obj.borrowCash = exports.LoanRequestFromBorrowCash.toJSON(message.borrowCash);
        }
        return obj;
    },
    create(base) {
        return exports.LoanRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLoanRequest();
        message.payment = (object.payment !== undefined && object.payment !== null)
            ? exports.LoanRequestFromPayment.fromPartial(object.payment)
            : undefined;
        message.borrowCash = (object.borrowCash !== undefined && object.borrowCash !== null)
            ? exports.LoanRequestFromBorrowCash.fromPartial(object.borrowCash)
            : undefined;
        return message;
    },
};
function createBaseLoanRequestFromPayment() {
    return { paymentId: '' };
}
exports.LoanRequestFromPayment = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.LoanRequestFromPayment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLoanRequestFromPayment();
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseLoanRequestFromBorrowCash() {
    return { amount: amount_1.Amount.fromPartial({}) };
}
exports.LoanRequestFromBorrowCash = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.LoanRequestFromBorrowCash.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLoanRequestFromBorrowCash();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseGetUserEligibilityRequest() {
    return {};
}
exports.GetUserEligibilityRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetUserEligibilityRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetUserEligibilityRequest();
        return message;
    },
};
function createBaseGetUserEligibilityResponse() {
    return {
        isEnabled: false,
        isDelinquent: false,
        fee: undefined,
        userEligibility: user_eligibility_1.UserEligibility.fromPartial({}),
        requirements: '',
    };
}
exports.GetUserEligibilityResponse = {
    fromJSON(object) {
        const message = {
            isEnabled: isSet(object.isEnabled) ? globalThis.Boolean(object.isEnabled) : false,
            isDelinquent: isSet(object.isDelinquent) ? globalThis.Boolean(object.isDelinquent) : false,
            userEligibility: isSet(object.userEligibility)
                ? user_eligibility_1.UserEligibility.fromJSON(object.userEligibility)
                : user_eligibility_1.UserEligibility.fromPartial({}),
            requirements: isSet(object.requirements) ? globalThis.String(object.requirements) : '',
        };
        if (isSet(object.fee)) {
            message.fee = fee_1.Fee.fromJSON(object.fee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isEnabled !== false) {
            obj.isEnabled = message.isEnabled;
        }
        if (message.isDelinquent !== false) {
            obj.isDelinquent = message.isDelinquent;
        }
        if (message.fee !== undefined) {
            obj.fee = fee_1.Fee.toJSON(message.fee);
        }
        if (message.userEligibility !== undefined) {
            obj.userEligibility = user_eligibility_1.UserEligibility.toJSON(message.userEligibility);
        }
        if (message.requirements !== '') {
            obj.requirements = message.requirements;
        }
        return obj;
    },
    create(base) {
        return exports.GetUserEligibilityResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUserEligibilityResponse();
        message.isEnabled = object.isEnabled ?? false;
        message.isDelinquent = object.isDelinquent ?? false;
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? fee_1.Fee.fromPartial(object.fee)
            : undefined;
        message.userEligibility =
            (object.userEligibility !== undefined && object.userEligibility !== null)
                ? user_eligibility_1.UserEligibility.fromPartial(object.userEligibility)
                : user_eligibility_1.UserEligibility.fromPartial({});
        message.requirements = object.requirements ?? '';
        return message;
    },
};
function createBaseGetPurchaseEligibilityRequest() {
    return { paymentId: '' };
}
exports.GetPurchaseEligibilityRequest = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.GetPurchaseEligibilityRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPurchaseEligibilityRequest();
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseGetPurchaseEligibilityResponse() {
    return { eligibility: loan_eligibility_1.LoanEligibility.fromPartial({}) };
}
exports.GetPurchaseEligibilityResponse = {
    fromJSON(object) {
        const message = {
            eligibility: isSet(object.eligibility)
                ? loan_eligibility_1.LoanEligibility.fromJSON(object.eligibility)
                : loan_eligibility_1.LoanEligibility.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.eligibility !== undefined) {
            obj.eligibility = loan_eligibility_1.LoanEligibility.toJSON(message.eligibility);
        }
        return obj;
    },
    create(base) {
        return exports.GetPurchaseEligibilityResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPurchaseEligibilityResponse();
        message.eligibility = (object.eligibility !== undefined && object.eligibility !== null)
            ? loan_eligibility_1.LoanEligibility.fromPartial(object.eligibility)
            : loan_eligibility_1.LoanEligibility.fromPartial({});
        return message;
    },
};
function createBaseGetLoanEligibilityRequest() {
    return { request: undefined, agreedToCreditPull: false };
}
exports.GetLoanEligibilityRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.request)) {
            message.request = exports.LoanRequest.fromJSON(object.request);
        }
        if (isSet(object.agreedToCreditPull)) {
            message.agreedToCreditPull = globalThis.Boolean(object.agreedToCreditPull);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.request !== undefined) {
            obj.request = exports.LoanRequest.toJSON(message.request);
        }
        if (message.agreedToCreditPull !== undefined && message.agreedToCreditPull !== false) {
            obj.agreedToCreditPull = message.agreedToCreditPull;
        }
        return obj;
    },
    create(base) {
        return exports.GetLoanEligibilityRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetLoanEligibilityRequest();
        message.request = (object.request !== undefined && object.request !== null)
            ? exports.LoanRequest.fromPartial(object.request)
            : undefined;
        message.agreedToCreditPull = object.agreedToCreditPull ?? false;
        return message;
    },
};
function createBaseGetLoanEligibilityResponse() {
    return { eligibility: loan_eligibility_1.LoanEligibility.fromPartial({}) };
}
exports.GetLoanEligibilityResponse = {
    fromJSON(object) {
        const message = {
            eligibility: isSet(object.eligibility)
                ? loan_eligibility_1.LoanEligibility.fromJSON(object.eligibility)
                : loan_eligibility_1.LoanEligibility.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.eligibility !== undefined) {
            obj.eligibility = loan_eligibility_1.LoanEligibility.toJSON(message.eligibility);
        }
        return obj;
    },
    create(base) {
        return exports.GetLoanEligibilityResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetLoanEligibilityResponse();
        message.eligibility = (object.eligibility !== undefined && object.eligibility !== null)
            ? loan_eligibility_1.LoanEligibility.fromPartial(object.eligibility)
            : loan_eligibility_1.LoanEligibility.fromPartial({});
        return message;
    },
};
function createBaseCreateLoanRequest() {
    return {
        paymentId: '',
        request: undefined,
        agreedToCreditPull: false,
        onlyActiveSubAccounts: false,
    };
}
exports.CreateLoanRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.paymentId)) {
            message.paymentId = globalThis.String(object.paymentId);
        }
        if (isSet(object.request)) {
            message.request = exports.LoanRequest.fromJSON(object.request);
        }
        if (isSet(object.agreedToCreditPull)) {
            message.agreedToCreditPull = globalThis.Boolean(object.agreedToCreditPull);
        }
        if (isSet(object.onlyActiveSubAccounts)) {
            message.onlyActiveSubAccounts = globalThis.Boolean(object.onlyActiveSubAccounts);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== undefined && message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.request !== undefined) {
            obj.request = exports.LoanRequest.toJSON(message.request);
        }
        if (message.agreedToCreditPull !== undefined && message.agreedToCreditPull !== false) {
            obj.agreedToCreditPull = message.agreedToCreditPull;
        }
        if (message.onlyActiveSubAccounts !== undefined && message.onlyActiveSubAccounts !== false) {
            obj.onlyActiveSubAccounts = message.onlyActiveSubAccounts;
        }
        return obj;
    },
    create(base) {
        return exports.CreateLoanRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateLoanRequest();
        message.paymentId = object.paymentId ?? '';
        message.request = (object.request !== undefined && object.request !== null)
            ? exports.LoanRequest.fromPartial(object.request)
            : undefined;
        message.agreedToCreditPull = object.agreedToCreditPull ?? false;
        message.onlyActiveSubAccounts = object.onlyActiveSubAccounts ?? false;
        return message;
    },
};
function createBaseCreateLoanResponse() {
    return { loan: account_1.Account.fromPartial({}), userEligibility: user_eligibility_1.UserEligibility.fromPartial({}) };
}
exports.CreateLoanResponse = {
    fromJSON(object) {
        const message = {
            loan: isSet(object.loan) ? account_1.Account.fromJSON(object.loan) : account_1.Account.fromPartial({}),
            userEligibility: isSet(object.userEligibility)
                ? user_eligibility_1.UserEligibility.fromJSON(object.userEligibility)
                : user_eligibility_1.UserEligibility.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.loan !== undefined) {
            obj.loan = account_1.Account.toJSON(message.loan);
        }
        if (message.userEligibility !== undefined) {
            obj.userEligibility = user_eligibility_1.UserEligibility.toJSON(message.userEligibility);
        }
        return obj;
    },
    create(base) {
        return exports.CreateLoanResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateLoanResponse();
        message.loan = (object.loan !== undefined && object.loan !== null)
            ? account_1.Account.fromPartial(object.loan)
            : account_1.Account.fromPartial({});
        message.userEligibility =
            (object.userEligibility !== undefined && object.userEligibility !== null)
                ? user_eligibility_1.UserEligibility.fromPartial(object.userEligibility)
                : user_eligibility_1.UserEligibility.fromPartial({});
        return message;
    },
};
function createBaseGetInstallmentAmountPaidRequest() {
    return { installmentId: '' };
}
exports.GetInstallmentAmountPaidRequest = {
    fromJSON(object) {
        const message = {
            installmentId: isSet(object.installmentId) ? globalThis.String(object.installmentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.installmentId !== '') {
            obj.installmentId = message.installmentId;
        }
        return obj;
    },
    create(base) {
        return exports.GetInstallmentAmountPaidRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetInstallmentAmountPaidRequest();
        message.installmentId = object.installmentId ?? '';
        return message;
    },
};
function createBaseGetInstallmentAmountPaidResponse() {
    return { amount: amount_1.Amount.fromPartial({}) };
}
exports.GetInstallmentAmountPaidResponse = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.GetInstallmentAmountPaidResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetInstallmentAmountPaidResponse();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseSendDenialNoticeRequest() {
    return {};
}
exports.SendDenialNoticeRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SendDenialNoticeRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSendDenialNoticeRequest();
        return message;
    },
};
function createBaseSendDenialNoticeResponse() {
    return {};
}
exports.SendDenialNoticeResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SendDenialNoticeResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSendDenialNoticeResponse();
        return message;
    },
};
function bnplErrorCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_BNPL_ERROR_CODE':
            return BnplErrorCode.INVALID_BNPL_ERROR_CODE;
        case 1:
        case 'BORROW_CIRCUIT_BREAKER':
            return BnplErrorCode.BORROW_CIRCUIT_BREAKER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return BnplErrorCode.UNRECOGNIZED;
    }
}
exports.bnplErrorCodeFromJSON = bnplErrorCodeFromJSON;
function bnplErrorCodeToJSON(object) {
    switch (object) {
        case BnplErrorCode.INVALID_BNPL_ERROR_CODE:
            return 'INVALID_BNPL_ERROR_CODE';
        case BnplErrorCode.BORROW_CIRCUIT_BREAKER:
            return 'BORROW_CIRCUIT_BREAKER';
        case BnplErrorCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.bnplErrorCodeToJSON = bnplErrorCodeToJSON;
/**
 * BNPL Public API
 */
class BnplServiceClient {
    rpc;
    name = 'com.step.bnpl.proto.BnplService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/bnpl';
    methods = [{
            name: 'GetUserEligibility',
            requestType: exports.GetUserEligibilityRequest,
            responseType: exports.GetUserEligibilityResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetPurchaseEligibility',
            requestType: exports.GetPurchaseEligibilityRequest,
            responseType: exports.GetPurchaseEligibilityResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetLoanEligibility',
            requestType: exports.GetLoanEligibilityRequest,
            responseType: exports.GetLoanEligibilityResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CreateLoan',
            requestType: exports.CreateLoanRequest,
            responseType: exports.CreateLoanResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'GetInstallmentAmountPaid',
            requestType: exports.GetInstallmentAmountPaidRequest,
            responseType: exports.GetInstallmentAmountPaidResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'SendDenialNotice',
            requestType: exports.SendDenialNoticeRequest,
            responseType: exports.SendDenialNoticeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Checks if a user is eligible for a BNPL loan.
     */
    getUserEligibility(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Checks if a purchase is eligible for a BNPL loan.
     */
    getPurchaseEligibility(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Checks if a loan is eligible for BNPL.
     */
    getLoanEligibility(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Creates a BNPL loan for a purchase.
     */
    createLoan(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Gets the amount that has been paid towards this installment.
     */
    getInstallmentAmountPaid(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Sends a denial notice email to the user.
     */
    sendDenialNotice(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.BnplServiceClient = BnplServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=bnpl-service.js.map